import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {connect} from '@modifi/redux'
import {compose} from 'ramda'

import {StyledIframe} from './styles'

const propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
}
const defaultProps = {}

export type IframeDialogProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const IframeDialog: React.FC<IframeDialogProps> = ({link, title}) => (
  <StyledIframe src={link} title={`${title}-frame`} width="100%" frameBorder={0} />
)

IframeDialog.propTypes = propTypes

IframeDialog.defaultProps = defaultProps

export const DIALOG_NAME = 'IFRAME_DIALOG'

const mapStateToProps = (state: any, ownProps: {params: {link: string; title: string}}) => ({
  ...ownProps.params,
})

export default compose(connect(mapStateToProps, null))(IframeDialog)
